@switch (columnName) {
  @case ('type') {
    {{ getTypeLabelKey() | translate }}
  }
  @case ('expires') {
    {{ element[columnName] | date }}
  }
  @case ('status') {
    <div
      [ngStyle]="{
        'background-color': element?.status === 'Expired' ? 'red' : 'gold',
      }"
      class="status"
    ></div>
  }
  @case ('name') {
    @if (element.expirationReason && element.category === dueListModules.Medicine) {
      @if (element.expirationReason === ExpirationReasonEnum.ExpirationDate) {
        <span>
          {{ 'expirationReasonExpiredDate' | translate }}
        </span>
      }
      @if (element.expirationReason === ExpirationReasonEnum.StockUnderMinimum) {
        <span>
          {{ 'expirationReasonStockUnderMinimum' | translate }}
        </span>
      }
      @if (element.expirationReason === ExpirationReasonEnum.ExpiredAndUnderMinimum) {
        <span>
          {{ 'expirationReasonExpiredAndUnderMinimume' | translate }}
        </span>
      }
    }
    {{ element.name }}
  }
  @case ('actions') {
    @if (
      element['category'] === dueListModules.Work || element['category'] === dueListModules.Drill
    ) {
      <button
        appStopClickPropagation
        mat-button
        [title]="'perform' | translate"
        (click)="
          saveLastItem(); dueListService.navigateToItem(performRouterLink, element.departmentId)
        "
      >
        <mat-icon>done</mat-icon>
      </button>
    }
    @if (element['category'] === dueListModules.MaintenanceJob) {
      <button
        mat-button
        appStopClickPropagation
        [title]="'perform' | translate"
        (click)="
          saveLastItem();
          dueListService.navigateToItem(performMaintenanceJobRouterLink, element.departmentId)
        "
      >
        <mat-icon>done</mat-icon>
      </button>
    }
  }
  @case ('placement') {
    @if (element['location'] | isSingleLevelPlacement) {
      {{ element['location'] }}
    } @else {
      <span [matTooltip]="element['location']">
        {{ element['location'] | splitForLastChildren: '/' }}
      </span>
    }
  }
  @case ('responsible') {
    @for (responsible of element.responsibles; track responsible) {
      <div>
        {{ responsible }}
      </div>
    }
  }
  @case ('department') {
    @if (element.departmentId) {
      {{ element.departmentName }}
    }
  }
  @default {
    <app-default-cell [element]="element" [columnName]="columnName"></app-default-cell>
  }
}
